export default function PHP_strchr() {
  return (
    <div>
      <h1>PHP_strchr</h1>
    </div>
  );
}
